<template>
    <div class="headerAddressMain">
        <div style="display:flex;align-items:center;flex-grow:1;overflow: hidden;">
            <div
                class="
                    leftArrowWrapper
                "
                @click="$router.go(-1)"
            >
                <i
                    class="iconfont icon-back leftArrow"
                    :style="{
                        color: fontColor,
                    }"
                ></i>
            </div>
            <div
                class="
                    labelWrapper
                "
                :style="{
                    color: fontColor,
                }"
            >
                <span v-if="label">{{ label }}</span>
                <slot v-else></slot>
            </div>
        </div>
        <div class="currentAddressTipWrapper">
            <CurrentAddressTip :fontColor="fontColor" :shopId="shopId"/>
        </div> 
    </div>
</template>

<script>

import CurrentAddressTip from '#/common_components/customerAddress/CurrentAddressTip.vue'

export default {
    name: "HeaderAddress",

    components: { CurrentAddressTip, },

    props: {
        label: {
            type: String,
            default: '',
        },

        fontColor: {
            type: String,
            default: '#ffffff'
        },

        shopId: {
            type: Number,
        }
    },
}
</script>

<style lang="scss" scoped>

.headerAddressMain {
    display: flex;
    box-sizing: border-box;
    font-size: $fontSizeContent;
}

//
.leftArrowWrapper
{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3em;
    flex-shrink: 0;
}

.leftArrow {
    font-size: $fontSizeContent;
    line-height: 3em;
    font-weight: 800;
}

//
.labelWrapper {
    font-size: $fontSizeContent;
    line-height: 3em;
    font-weight: 800;
    flex-grow: 1;
    overflow: scroll;
}

//
.currentAddressTipWrapper
{
    display: flex;
    align-items: center;
    flex-shrink: 0;
    margin: 0 $margin;
    width: calc(10 * #{$fontSizeContent});
    font-size: $fontSizeContent;
    line-height: calc(2 * #{$fontSizeContent});
}
</style>


